export default __webpack_public_path__ + "static/media/google.e533c106.png";